export default __webpack_public_path__ + "static/media/BrainBreak cards37.c859a64c.png";